module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/image-placeholder-a9b3b9bf60cc3621676ae90dc800402e.svg";